import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/team';

export default {
	/**
	 * Get Team Members
	 * @param {Object} params Params
	 * @param {number} params.limit Limit
	 * @param {string} params.sort_by Sort By
	 * @param {'asc' | 'desc'} params.sort Sort
	 * @param {number} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {boolean} [params.include_owner] Include Owner
	 * @param {requestCallback} [cb] Response Callback
	 * @param {errorCallback} [errorCb] Error Callback
	 */
	getMembers(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/members?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	createMember(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			payment_ids: idsJSON,
		};

		client.delete(url, { data: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	getSchedule(id, cb, errorCb) {
		const url = `${endpoint}/${id}/schedule`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateSchedule(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/schedule`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateStatus(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/is_active`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Change Member Status
	 *
	 * @param {string} id Team Member ID
	 * @param {object} params Params
	 * @param {0|1} params.on_duty On Duty
	 * @param {*} cb Success Callback
	 * @param {*} errorCb Error Callback
	 */
	changeStatus(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/on_duty`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
